import { Checkbox } from "../../../../components/Checkbox";
import { RadioButton } from "../../../../components/RadioButton";

export function StatusSelect({
    selectedStatus,
    setSelectedStatus,
    statusOptions = [],
}: {
    selectedStatus: string;
    setSelectedStatus: (status: string) => void;
    statusOptions?: any[];
}) {
    return (
        <div className="flex-1 flex flex-col gap-2">
            <div className="text-base font-medium">Select Status</div>
            <div className="flex flex-col gap-0.5 max-h-[175px] overflow-y-auto">
                {
                    statusOptions.map((option) => (
                        <RadioButton className="hover:bg-[#F1F1F1] w-[140px] p-2 rounded-[6px]" checked={selectedStatus === option.value} onChange={() => setSelectedStatus(option.value)} label={option.label} id={option.value} key={option.value} />
                    ))
                }
            </div>
        </div>
    )
}